import {Simulate} from "react-dom/test-utils";
import mouseUp = Simulate.mouseUp;
import {EventManager} from "shared/utilities/Events/EventManager";

import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {OpenProperties} from "PageBuilder/Events/OpenProperties";
import {PDFDocument} from "PageBuilder/pagebuilder/PDFDocument";
import {ShowGroupOptions} from "PageBuilder/Events/ShowGroupOptions";
import {HTMLUtils} from "PageBuilder/utils/HTMLUtils";



export class GroupManager {
    private pdfDocument:PDFDocument;
    private IsDragging:boolean=false;
    private OriginalPosition:Position;
    private square:HTMLDivElement=null;

    public static Current:GroupManager;

    public SelectedElements:PDFControlBase[]=[];
    private constructor(pdfDocument:PDFDocument) {
        this.pdfDocument=pdfDocument;
        this.OnMouseMove=this.OnMouseMove.bind(this);
        this.OnMouseUp=this.OnMouseUp.bind(this);
        document.getElementById('DocumentWorkArea').addEventListener('mousedown',(e:MouseEvent)=>{
            this.OnMouseDown(e);
        });
    }


    static Initialize(pdfDocument:PDFDocument){
        if(GroupManager.Current==null)
            GroupManager.Current=new GroupManager(pdfDocument);

    }

    private OnMouseDown(e: MouseEvent) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.ClearSelection();
        if(PDFControlBase.SelectedElements.length>0) {
            PDFControlBase.ClearSelection();
        }
        e.stopPropagation();
        this.IsDragging=true;
        this.OriginalPosition={x:0,y:0};
        this.OriginalPosition.x=e.clientX+(window.pageXOffset||document.documentElement.scrollLeft);
        this.OriginalPosition.y=e.clientY+(window.pageYOffset||document.documentElement.scrollTop);
        document.addEventListener('mousemove',this.OnMouseMove);
        document.addEventListener('mouseup',this.OnMouseUp);
    }

    private OnMouseMove(e:MouseEvent){




        if(this.square==null)
            this.CreateSquare();

        let currentPosition:Position={x:e.clientX+(window.pageXOffset||document.documentElement.scrollLeft),y: e.clientY+(window.pageYOffset||document.documentElement.scrollTop)};

        let initialCoordinate:Position={x:0,y:0};
        let endCoordinate:Position={x:0,y:0};
        if(this.OriginalPosition.x<=currentPosition.x)//is expanding to right
        {
            initialCoordinate.x=this.OriginalPosition.x;
            endCoordinate.x=currentPosition.x;
        }else{
            initialCoordinate.x=currentPosition.x;
            endCoordinate.x=this.OriginalPosition.x;
        }


        if(this.OriginalPosition.y<=currentPosition.y)//is expanding to bottom
        {
            initialCoordinate.y=this.OriginalPosition.y;
            endCoordinate.y=currentPosition.y;
        }else{
            initialCoordinate.y=currentPosition.y;
            endCoordinate.y=this.OriginalPosition.y;
        }


        this.square.style.top=initialCoordinate.y+'px';
        this.square.style.left=initialCoordinate.x+'px';
        this.square.style.width=(endCoordinate.x-initialCoordinate.x)+'px';
        this.square.style.height=(endCoordinate.y-initialCoordinate.y)+'px';

        this.SelectElements(initialCoordinate,endCoordinate);


    }

    private OnMouseUp(e:MouseEvent)
    {
        document.removeEventListener("mousemove", this.OnMouseMove);
        document.removeEventListener("mouseup", this.OnMouseUp);
        if(this.square!=null) {
            this.square.remove();
            this.square = null;
        }
        this.IsDragging=false;

        if(this.SelectedElements.length>0)
        {
            if(this.SelectedElements.length==1)
                EventManager.Publish(new OpenProperties(this.SelectedElements[0]));
            else
                EventManager.Publish(new ShowGroupOptions());
        }else{
            EventManager.Publish(new OpenProperties(null));
        }
    }

    private CreateSquare() {
        this.square=document.createElement('div');
        this.square.style.position='absolute';
        this.square.style.border='1px dashed black';
        this.square.style.zIndex='10000000';

        document.body.appendChild(this.square);
    }

    private SelectElements(initialCoordinate: Position, endCoordinate: Position) {
        let initialRelative:Position={
            x:initialCoordinate.x-this.pdfDocument.RootContainer.offsetLeft,
            y:initialCoordinate.y-this.pdfDocument.RootContainer.offsetTop
        };


        let endRelative:Position={
            x:endCoordinate.x-this.pdfDocument.RootContainer.offsetLeft,
            y:endCoordinate.y-this.pdfDocument.RootContainer.offsetTop
        };

        this.ClearSelection();

        let components=this.pdfDocument.components;

        for(let component of components)
        {
            if(this.HitTest(this.square,component.$element[0])) {
                this.SelectedElements.push(component);
                component.Select();
            }
        }

    }

    private HitTest ( a:HTMLElement, b:HTMLElement ) {
        var pos1 = this.GetPositions( a ),
            pos2 = this.GetPositions( b );
        return this.ComparePositions( pos1[0], pos2[0] ) && this.ComparePositions( pos1[1], pos2[1] );
    }

    private ComparePositions( p1, p2 ) {
        var r1, r2;
        r1 = p1[0] < p2[0] ? p1 : p2;
        r2 = p1[0] < p2[0] ? p2 : p1;
        return r1[1] > r2[0] || r1[0] === r2[0];
    }


    private GetPositions( elem ) {
        var pos, width, height;
        pos = HTMLUtils.GetOffset(elem);
        width = jQuery( elem ).width();
        height = jQuery( elem ).height();
        return [ [ pos.left, pos.left + width ], [ pos.top, pos.top + height ] ];
    }

    public ClearSelection() {
        for(let previouslySelectedElement of this.SelectedElements)
            previouslySelectedElement.DeSelect();

        this.SelectedElements=[];
    }

    ElementOfDifferentSectionsWhereSelected() {
        for(let i=1;i<this.SelectedElements.length;i++)
        {
            if(this.SelectedElements[i].Options.TargetId!=this.SelectedElements[i-1].Options.TargetId)
                return true;
        }

        return false;
    }



    HandleGroupMovement(event: MouseEvent) {
        event.stopPropagation();
        let originalPosition:Position={
            x:event.pageX,
            y:event.pageY
        };


        let originalElementsPosition:{Item:PDFControlBase,Position:Position}[]=[];

        for(let item of this.SelectedElements)
        {
            originalElementsPosition.push(
                {
                    Item: item,
                    Position: {
                        y: item.GetRelativeTop(),
                        x: item.GetRelativeLeft()
                    }
                });
        }


        let mouseMove=evt => {
            let deltaX=evt.pageX-originalPosition.x;
            let deltaY=evt.pageY-originalPosition.y;


            for(let element of originalElementsPosition)
            {
                element.Item.MoveTo(element.Position.x+deltaX+'px',element.Position.y+deltaY+'px');
            }


        };

        let mouseUp=evt=>{
            document.removeEventListener('mousemove',mouseMove);
            document.removeEventListener('mouseup',mouseUp);

            for(let element of originalElementsPosition)
            {
                element.Item.RecalculateParentSectionAndPosition();
            }
        };


        document.addEventListener('mousemove',mouseMove);
        document.addEventListener('mouseup',mouseUp);

    }
}

interface Position {
    x:number;
    y:number;
}

